import { projektGajaChapters } from './content';
export const projektGajaGlossary = projektGajaChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('GLOSSARY'));
